import { DemandStatus } from '../../Enums/demand-status.enum';

export class ApplicationDemand {
  id?: string;
  reference?: string;
  status?: DemandStatus;
  status_id?: number;
  created_at?: string;

  constructor(data?: Partial<ApplicationDemand>) {
    Object.assign(this, data);
  }
}
